<template>
    <DataTable :url="api.ACTIONS.ROLES"
               :fieldsHiddenMain="['guard_name', 'permissions']"
               :fieldsHiddenEdit="['guard_name','permissions_count','id','created_at','updated_at']"
               :fieldsDisabledEdit="['id','created_at','updated_at','permissions_count']"
               :fieldsHiddenAdd="['guard_name','id','created_at','updated_at','permissions_count']"
               :fieldsExtraAdd="fieldsExtraAdd"
               :fieldsExtraEdit="fieldsExtraEdit"
               :fieldsExtraMain="fieldsExtraMain"
               :formatter="formatter"
               :dialogMaxWidth="'700px'"
               loadBeforeEdit
               :titles="titles"
               :title="$t('staffPage.rolesPageTitle')"

    />
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";

    import api from "@/constants/api.js";

    export default {
        name: "Roles",
        title() {
            return this.$t("staffPage.rolesPageTitle");
        },
        components: {DataTable},
        data() {
            return {
                api,
                permissionsMap: {} // Cache for permission names
            }
        },
        computed: {
            titles() {
                return {
                    "id": "#",
                    "name": this.$t("staffPage.colName"),
                    "created_at": this.$t("staffPage.createdAt"),
                    "updated_at": this.$t("staffPage.updatedAt"),
                    "permissions_count": this.$t("staffPage.permissionsCount"),
                    "permissions": this.$t("staffPage.permissions")
                };
            },
            fieldsExtraAdd: () => ({
                permissions: "choose-permissions-multi"
            }),
            fieldsExtraEdit: () => ({
                permissions: "choose-permissions-multi"
            }),
            fieldsExtraMain: () => ({
                permissions: "display-permissions-list"
            }),
            formatter() {
                return {
                    permissions_count: (value) => {
                        return value || 0;
                    },
                    permissions: (value, mode, item) => {
                        if (mode === 'show' && value && Array.isArray(value) && value.length > 0) {
                            return `<span class="permissions-badge">${this.$t("staffPage.permissionsBadge", { count: value.length })}</span>`;
                        }
                        return value && Array.isArray(value) ? value.length : 0;
                    }
                }
            }
        },
        mounted() {
            // Load permissions to cache names
            this.axios.get(this.api.ACTIONS.PERMISSIONS)
                .then(res => {
                    const {data} = res.data;
                    data.forEach(perm => {
                        this.permissionsMap[perm.id] = perm.name;
                    });
                })
                .catch(err => console.log(err));
        }
    }
</script>

<style scoped>

</style>